module.exports = __webpack_public_path__ + "img/404.5be2ae2.gif";